package one.healthium.rateus.data

@androidx.compose.runtime.Composable
actual fun RateApp() {
}